// extracted by mini-css-extract-plugin
module.exports = {"header":"_3WKxw","logoImage":"_1FRHG","phone":"_2oL4n","phone_icon":"_3celM","phone_text":"ffz0s","row":"_1B8rt","aside":"__Grc","cart":"_3cvZw"};